export const constantsStorage = {
  token: '@ExchangeSpot:token',
  profile: '@ExchangeSpot:profile',
  navigationHistory: '@ExchangeSpot:navigation_history',
}
